
import FooterCarousel from "./FooterCarousel";

import "./footer.scss";



const Footer = () => {
  return (
    <footer
      className="footer bgImg bgImgFixed"
      style={{ backgroundColor: '#000' }}
    >
      <div className="container">
        <div className="footerInfo">
          <div className="footerDetails">
            <h1>Services</h1>
            <a href="#home">
              <p>Se lo llevamos a su casa</p>
            </a>
            <a href="#menu">
              <p>Los mejores precios</p>
            </a>
          </div>
          <div className="footerDetails">
            <h1>Information</h1>
            <a href="#contact">
              <p>Contact us</p>
            </a>
            <a href="#home">
              <p>Terms of services</p>
            </a>
          </div>
        </div>
  </div>
  <FooterCarousel />
  <p className="license">copyright 2025 &#169; <a href="https://repoportfolio.pages.dev/" target="_blank" rel="noopener noreferrer" style={{color: '#fff', textDecoration: 'underline'}}>Ing. Yeudi Martínez</a></p>
    </footer>
  );
};

export default Footer;
